import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./drag-and-drop.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./drag-and-drop.component.scss?ngResource";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AlertType } from "../../models/alert";
import { AppControllerService } from "../../../app-controller.service";
let DragAndDropComponent = class DragAndDropComponent {
    appController;
    fileDragged = new EventEmitter();
    fileForm;
    fileName;
    maxFileSize;
    allowedFiles;
    showLastUploadedFile = true;
    uploadedFiles = [];
    deleteFile = new EventEmitter();
    constructor(appController) {
        this.appController = appController;
    }
    ngOnInit() {
        if (this.fileName) {
            this.uploadedFiles.push(this.fileName);
        }
    }
    uploadFile(files) {
        if (files.length === 0) {
            return;
        }
        const fileToUpload = files[0];
        const fileExtension = fileToUpload.name.substring(files[0].name.lastIndexOf(".") + 1).toUpperCase();
        let isFileAllowed = false;
        this.allowedFiles.forEach(element => {
            if (element.toUpperCase() === fileExtension) {
                isFileAllowed = true;
            }
        });
        if (!isFileAllowed) {
            const allowedExtensions = this.allowedFiles.join(",");
            this.appController.showMessage(`The file you have selected is not supported: ${fileExtension}.\n
       Please choose a different file. Only files with the following extensions are supported: ${allowedExtensions}.`, AlertType.Warning);
            return;
        }
        if (this.maxFileSize !== undefined && this.maxFileSize !== null && fileToUpload.size > this.maxFileSize) {
            this.appController.showMessage(`Attached file size is ${this.bytesToSize(fileToUpload.size)} and allowed file size is ${this.bytesToSize(this.maxFileSize)}`, AlertType.Warning);
            return;
        }
        this.fileDragged.emit(fileToUpload);
        this.uploadedFiles[0] = fileToUpload.name;
    }
    bytesToSize(bytes) {
        const sizes = ["Bytes", "KB", "MB", "GB"];
        if (bytes === 0)
            return "0 Byte";
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
        if (i === 0)
            return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }
    deleteAttachment(index) {
        this.uploadedFiles.splice(index, 1);
        this.deleteFile.emit(index);
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
    static propDecorators = {
        fileDragged: [{ type: Output }],
        fileForm: [{ type: Input }],
        fileName: [{ type: Input }],
        maxFileSize: [{ type: Input }],
        allowedFiles: [{ type: Input }],
        showLastUploadedFile: [{ type: Input }],
        deleteFile: [{ type: Output }]
    };
};
DragAndDropComponent = __decorate([
    Component({
        selector: "app-drag-and-drop",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], DragAndDropComponent);
export { DragAndDropComponent };
